import { Modal, Stack, VStack } from '@components/Customized';
import { Image } from '@components/Image';
import { useTheme, useMediaQuery, makeStyles } from '@material-ui/core';

export interface RequestActionDialogBaseProps {
  open: boolean;
  iconSrc: string;
  title: string;
  description: string;
  ButtonComponent: React.ReactNode;
  onClose?: () => void;
}
export type RequestActionDialogProps = Pick<
  RequestActionDialogBaseProps,
  'open' | 'onClose'
> & { variant?: 'account' | 'default' };

const RequestActionDialogBase = ({
  ButtonComponent,
  description,
  iconSrc,
  open,
  title,
  onClose
}: RequestActionDialogBaseProps) => {
  const { desciprtion } = useStyles();
  const matches = useMediaQuery(useTheme().breakpoints.down('md'));
  const iconSize = matches ? 72 : 100;

  return (
    <Modal open={open} onClose={() => onClose?.()}>
      {onClose && <Modal.CloseButton onClose={onClose} />}
      <Modal.ContentSection>
        <VStack
          width={'100%'}
          justifyContent="center"
          alignItems="center"
          margin={`56px 0px 0px 0px`}
        >
          <Image width={iconSize} height={iconSize} src={iconSrc} />
          <Stack height={24} />
          <Modal.Text
            variant={matches ? 'h4' : 'h3'}
            fontWeight="700"
            gutterBottoms={12}
            className={desciprtion}
          >
            {title}
          </Modal.Text>
          <Modal.Text
            variant={matches ? 'body2' : 'body1'}
            className={desciprtion}
          >
            {description}
          </Modal.Text>
        </VStack>
      </Modal.ContentSection>
      <Modal.ButtonSection>{ButtonComponent}</Modal.ButtonSection>
    </Modal>
  );
};

export default RequestActionDialogBase;

const useStyles = makeStyles(
  {
    desciprtion: {
      whiteSpace: 'break-spaces',
      textAlign: 'center'
    }
  },
  { classNamePrefix: 'RequestActionDialogBase-' }
);
